import api from "@/services/api";
import { AddProduct, PaginatedResponse } from "@/types";
import {
  ScrapedProduct,
  ScrapedProductFilters,
  UpdateScrapedProduct,
} from "@/types/scraped-product";

export class ScrapedProductRepository {
  async findAll(
    filters: ScrapedProductFilters,
  ): Promise<PaginatedResponse<ScrapedProduct>> {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      // Include boolean false, but exclude undefined, null, and empty strings
      if (
        value !== undefined &&
        value !== null &&
        (typeof value === "boolean" || value !== "")
      ) {
        params.append(key, value.toString());
      }
    });

    const response = await api.get(
      `/v1/admin/scrape-products?${params.toString()}`,
    );

    return response.data as PaginatedResponse<ScrapedProduct>;
  }

  async update(data: UpdateScrapedProduct): Promise<ScrapedProduct> {
    const response = await api.patch<ScrapedProduct>(
      `/v1/admin/scrape-products/${data.id}`,
      {
        blacklist: data.blacklist,
        reviewRequired: data.reviewRequired,
      },
    );

    return response.data;
  }

  async import(id: string, data: AddProduct): Promise<ScrapedProduct> {
    const response = await api.post<ScrapedProduct>(
      `/v1/admin/scrape-products/${id}/import`,
      data,
    );

    return response.data;
  }

  async associate(
    scrapedProductIds: Array<string>,
    productId: string,
  ): Promise<ScrapedProduct> {
    const response = await api.post<ScrapedProduct>(
      `/v1/admin/scrape-products/bulk-associate`,
      {
        scrapedProductIds,
        productId,
      },
    );

    return response.data;
  }

  async disassociate(
    scrapedProductIds: Array<string>,
  ): Promise<ScrapedProduct> {
    const response = await api.post<ScrapedProduct>(
      `/v1/admin/scrape-products/bulk-disassociate`,
      {
        scrapedProductIds,
      },
    );

    return response.data;
  }
}
